import React from "react";

const PRIORITY_STYLES = {
  1: "bg-critical/15 text-critical border-critical/40",
  2: "bg-warning/15 text-warning border-warning/40",
  3: "bg-primary/15 text-primary border-primary/40",
  4: "bg-white/5 text-muted border-line",
  5: "bg-white/5 text-faint border-line",
};

export function Badge({ children, className = "", tone }) {
  const toneCls = tone ? PRIORITY_STYLES[tone] : "bg-white/5 text-muted border-line";
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-sm border text-[10px] uppercase tracking-wider font-medium mono ${toneCls} ${className}`}
    >
      {children}
    </span>
  );
}
